import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseURL } from "../../BaseUrl";
import Swal from "sweetalert2";

// Function to retrieve token from localStorage
const getToken = () => localStorage.getItem("workManagement");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

export const getAllUserdata = createAsyncThunk(
  "users/getAllUserdata",
  async () => {
    try {
      // console.log("authtnk", getAuthHeaders())
      const response = await baseURL.get(
        `user/`,
        getAuthHeaders()
      );
      // console.log("response.data", response.data);
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
export const createUserdata = createAsyncThunk(
  "users/createUserdata",
  async (data) => {
    try {
      const response = await baseURL.post(
        `auth/signup/`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
export const getSingleUserdata = createAsyncThunk(
  "users/getSingleUserdata",
  async (id) => {
    // console.log("id===>",id)
    try {
      const response = await baseURL.get(`user/${id}`,getAuthHeaders());
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
export const updateeUserdata = createAsyncThunk(
  "users/updateeUserdata",
  async (data) => {
    try {
      const response = await baseURL.patch(`user`,data,getAuthHeaders());
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
export const getCompanyList = createAsyncThunk(
  "users/getCompanyList",
  async () => {
    try {
      // console.log("authtnk", getAuthHeaders())
      const response = await baseURL.get(
        `company/companylist`,
        getAuthHeaders()
      );
      // console.log("response.data", response.data);
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
export const getDepartmentList = createAsyncThunk(
  "users/getDepartmentList",
  async (cid) => {
    // console.log("cid===>",cid)
    try {
      const response = await baseURL.get(`department/deptlist/${cid}`,getAuthHeaders());
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
//delete 
export const deleteUserData = createAsyncThunk(
  "users/deleteUser",
  async (id) => {
    // console.log("cid===>",cid)
    try {
      const response = await baseURL.delete(`user/delete-user/${id}`,getAuthHeaders());
      // console.log("response.data", response.data)
      return response.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      Swal.fire({
        icon: "error",
        title: `${error.response.data.message}`,
      });
      // throw error; // Ensure the error is propagated
    }
  }
);
//email validation
export const emailValidationAPI = createAsyncThunk(
  "users/emailValidationAPI",
  async (data) => {
    try {
      const response = await baseURL.post(
        `user/sendmail/`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
//otp verification
export const otpValidationAPI = createAsyncThunk(
  "users/otpValidationAPI",
  async (data) => {
    try {
      const response = await baseURL.post(
        `user/verifymail/`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
//change password
export const changePasswordAPI = createAsyncThunk(
  "users/changePasswordAPI",
  async (data) => {
    try {
      const response = await baseURL.patch(
        `user/confirm-pass`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`)
      throw error; // Ensure the error is propagated
    }
  }
);
//to download the employee qr code in format
export const employeeQRCodeDownload = createAsyncThunk(
  "qr/employeeQRCodeDownload",
  async (data) => {
    try {
      const response = await baseURL.post(`/employee-qr-code`, data);
      // console.log("response", response);
      return response.data;
    } catch (error) {
      // console.log(error);
      return error.response.data;
    }
  }
);
// login SLICE
export const userSlice = createSlice({
  name: "user",
  initialState: {
    userData: [],
    singleUserData: {},
    companyList:[],
    departmentList:[],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllUserdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUserdata.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload;
      })
      .addCase(getAllUserdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getSingleUserdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSingleUserdata.fulfilled, (state, action) => {
        state.loading = false;
        // state.singleUserData = action.payload.userData;
        state.singleUserData = action.payload;
      })
      .addCase(getSingleUserdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
      builder
      .addCase(getCompanyList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyList.fulfilled, (state, action) => {
        state.loading = false;
        state.companyList = action.payload;
      })
      .addCase(getCompanyList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
      builder
      .addCase(getDepartmentList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDepartmentList.fulfilled, (state, action) => {
        state.loading = false;
        state.departmentList = action.payload;
      })
      .addCase(getDepartmentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

// SELECTORS
export const getUsersData = (state) => state.user.userData;
export const getSingleUsersData = (state) => state.user.singleUserData;
export const getAllCompanyList = (state) => state.user.companyList;
export const getAllDepartmentList = (state) => state.user.departmentList;
export const loginerror = (state) => state.user.loading;

// EXPORTS
export default userSlice.reducer;
